import { render } from "./Home.vue?vue&type=template&id=dc56835c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=dc56835c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc56835c"]])

export default __exports__